// statsCounter JS, for animating number counts in new theme 
// datarobot6/views/gutenberg/content/dr-stats-module.twig
// datarobot6/views/gutenberg/content/dr-stats-module-light.twig

document.addEventListener("DOMContentLoaded", () => {


    // Function to animate counting up for integers and decimals
    function animateCountUp(element, targetValue, duration = 2000) {
        let startValue = 0;
        let startTime = null;

        // Determine if the target value is a decimal
        const isDecimal = targetValue % 1 !== 0;

        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            const currentValue = startValue + progress * (targetValue - startValue);

            // Format the number: decimals keep 1 digit, integers are rounded
            element.textContent = isDecimal
                ? currentValue.toFixed(1)
                : Math.floor(currentValue).toLocaleString();

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                // Ensure the final value is accurate
                element.textContent = isDecimal
                    ? targetValue.toFixed(1)
                    : targetValue.toLocaleString();
            }
        }

        requestAnimationFrame(step);
    }

    // Set up IntersectionObserver to trigger the animation when visible
    const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.3 // Trigger when 30% visible
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counter = entry.target;
                const targetValue = parseFloat(counter.textContent.replace(/,/g, ''));

                if (!isNaN(targetValue) && !counter.classList.contains('counted')) {
                    animateCountUp(counter, targetValue);
                    counter.classList.add('counted'); // Prevents re-triggering
                }

                observer.unobserve(counter); // Stops observing after animation
            }
        });
    }, observerOptions);

    // Target all counters on the page
    const counters = document.querySelectorAll('.statsModule__statsCounter');
    counters.forEach(counter => {
        observer.observe(counter);
    });



	// console.log("statsCounter loading test");
});
